import React from 'react';
import {isEmpty as _isEmpty} from 'lodash';
import PropTypes from 'prop-types';

import {renderProductColumnForComputerVision} from '@utils/tableHelpers';
import {IconEdit, IconInfoCircle, IconWithTooltip} from '@appComponents/IconCollection';
import {getLink} from '@appComponents/Link';
import {ENCODING_TARGET} from '@constants/resources';
import IconsAudioConfiguration from '@modules/events/views/EventsConfigurationTargetsTable/IconsAudioConfiguration';
import IconsSubtitleConfiguration from '@modules/events/views/EventsConfigurationTargetsTable/IconsSubtitleConfiguration';
import {Authorization} from '@appComponents/Authorization';
import {
    authorizationAudioReadObject,
    authorizationEncodingTargetReadObject,
    authorizationSubtitleReadObject,
} from '@modules/events/components/EventsConfigurationTargets/components/Table/authorizationObject';
import {
    renderCheckbox,
    getIconWarningText,
    renderDistributionType,
    renderListOfNameOfFirstLevelDependency,
    setCdnColumn,
} from '@modules/events/components/EventsConfigurationTargets/utils/helpers';

export const RowRenderer = (column, row, props) => {
    const {content, eventId, eventContentId} = props;

    const cdnColumn = setCdnColumn(column, row);
    const iconWarningText = getIconWarningText(row);

    switch (column) {
        case 'product':
            return renderProductColumnForComputerVision(row.product.name, row.is_computer_vision);
        case 'distribution_type':
            return renderDistributionType(row);
        case 'cdn':
            return <div>{cdnColumn}</div>;
        case 'ingest_method':
            return row[column] ? row[column].name : null;
        case 'stream_delay_type':
            return <div>{row[column] ? `${row[column].name}` : ''}{row.delay ? ` (${row.delay}s)` : ''}</div>;
        case 'device_categories':
            return renderListOfNameOfFirstLevelDependency(row, column);
        case 'has_playback_authentication':
            return (
                <>
                    {renderCheckbox(row, column)}
                    {null !== row.token_ttl && <IconInfoCircle tooltip={`Token TTL: ${row.token_ttl}s`} />}
                </>
            );
        case 'is_default':
        case 'has_slate_support':
        case 'has_overlay_support':
        case 'has_ad_support':
        case 'has_scoreboard_overlay_support':
        case 'has_drm_support':
        case 'has_watermarking_support':
        case 'has_cc':
            return renderCheckbox(row, column);
        case 'actions' :
            return (
                <div className='actions-list-icon'>
                    <Authorization
                        authorization={authorizationEncodingTargetReadObject}
                    >
                        <IconEdit size='large' link={
                            getLink(
                                'events.configuration.content.target.edit',
                                {id: eventId, contentId: eventContentId, targetId: row.id}
                            )
                        }
                        resource={ENCODING_TARGET}
                        />
                    </Authorization>
                    <Authorization authorization={authorizationAudioReadObject}>
                        <IconsAudioConfiguration
                            content={content}
                            tableRow={row}
                        />
                    </Authorization>
                    <Authorization authorization={authorizationSubtitleReadObject}>
                        <IconsSubtitleConfiguration
                            content={content}
                            tableRow={row}
                        />
                        {
                            (!_isEmpty(iconWarningText))
                                ? <IconWithTooltip
                                    name='info circle'
                                    iconProps={{size: 'large'}}
                                    popupProps={{
                                        wide: 'very',
                                        position: 'top right',
                                    }}
                                    tooltip={iconWarningText}
                                />
                                : null
                        }
                    </Authorization>
                </div>
            );
        default:
            return null;
    }
};

RowRenderer.propTypes = {
    content: PropTypes.object.isRequired,
    eventContentId: PropTypes.number.isRequired,
    eventId: PropTypes.number.isRequired,
};
